// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3v0m8","header":"ReportDetails_header__2ile8","title":"ReportDetails_title__1TFm7","left":"ReportDetails_left__1evrb"};